import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { ProposalProductItemType } from '@econtractor/types';
import ProductsTableRow, { type ProductsTableRowProps } from './ProductsTableRow';

type ProductsTableBodyProps = Omit<ProductsTableRowProps, 'row' | 'index' | 'sortableId'> & {
    products: ProposalProductItemType[];
    sortable?: boolean;
};

const ProductsTableBody = ({ products, sortable = false, table, ...rowProps }: ProductsTableBodyProps) => {
    const rows = products.map((row, index) => (
        <ProductsTableRow
            key={table.getRowId(row, index)}
            row={row}
            index={index}
            sortableId={sortable ? table.getRowId(row, index) : undefined}
            table={table}
            {...rowProps}
        />
    ));

    return (
        <tbody>
            {sortable ? (
                <SortableContext
                    items={products.map((row, index) => table.getRowId(row, index))}
                    strategy={verticalListSortingStrategy}
                >
                    {rows}
                </SortableContext>
            ) : (
                rows
            )}
        </tbody>
    );
};

export default ProductsTableBody;
